@if (status() === 'reported') {
  <p #result class="erf-success" role="status" tabindex="-1">
    {{ 'ERROR_REPORTING.FORM.ALREADY_REPORTED' | translate }}
  </p>
} @else if (status() === 'success' || status() === 'queued') {
  <div #result class="erf-success" role="status" tabindex="-1">
    @if (showResultTitle()) {
      <h3 class="erf-success__title">
        {{
          (status() === 'queued' ? 'ERROR_REPORTING.FORM.QUEUED_TITLE' : 'ERROR_REPORTING.FORM.SUCCESS_TITLE') | translate
        }}
      </h3>
    }
    <p class="erf-success__text">
      {{
        (status() === 'queued' ? 'ERROR_REPORTING.FORM.QUEUED_TEXT' : 'ERROR_REPORTING.FORM.SUCCESS_TEXT') | translate
      }}
      @if (resultUrl()) {
        {{ 'ERROR_REPORTING.FORM.SUCCESS_TRACK' | translate }}
        <a class="erf-link" [href]="resultUrl()" target="_blank" rel="noopener noreferrer">
          {{ 'ERROR_REPORTING.FORM.SUCCESS_LINK' | translate }}</a
        >.
      }
    </p>
  </div>
} @else {
  <form class="erf" [formGroup]="form" (ngSubmit)="submit()">
    <p class="erf-intro">
      {{ (isFeedback() ? 'ERROR_REPORTING.FEEDBACK.INTRO' : 'ERROR_REPORTING.FORM.INTRO') | translate }}
    </p>

    <fieldset class="erf-fields" [disabled]="status() === 'sending' || status() === 'uncertain'">
      <label class="erf-field">
        <span class="erf-field__label">{{
          (isFeedback() ? 'ERROR_REPORTING.FEEDBACK.MESSAGE_LABEL' : 'ERROR_REPORTING.FORM.COMMENT_LABEL') | translate
        }}</span>
        <textarea
          class="erf-input erf-input--area"
          formControlName="comment"
          rows="3"
          maxlength="2000"
          [placeholder]="
            (isFeedback() ? 'ERROR_REPORTING.FEEDBACK.MESSAGE_PLACEHOLDER' : 'ERROR_REPORTING.FORM.COMMENT_PLACEHOLDER')
              | translate
          "
          required
          aria-describedby="erf-visibility-note"
          [attr.aria-invalid]="form.controls.comment.touched && form.controls.comment.invalid"></textarea>
        @if (form.controls.comment.touched && form.controls.comment.invalid) {
          <span class="erf-field__error">{{ 'ERROR_REPORTING.FORM.COMMENT_REQUIRED' | translate }}</span>
        }
      </label>

      @if (showEmail()) {
        <label class="erf-field">
          <span class="erf-field__label">{{ 'ERROR_REPORTING.FORM.EMAIL_LABEL' | translate }}</span>
          <input
            class="erf-input"
            type="email"
            formControlName="email"
            placeholder="you@example.com"
            autocomplete="email"
            maxlength="254"
            [attr.aria-invalid]="form.controls.email.touched && form.controls.email.invalid" />
          @if (form.controls.email.touched && form.controls.email.invalid) {
            <span class="erf-field__error">{{ 'ERROR_REPORTING.FORM.EMAIL_INVALID' | translate }}</span>
          }
        </label>
      }

      <p id="erf-visibility-note" class="erf-field__note">
        {{ 'ERROR_REPORTING.FORM.PUBLIC_NOTE' | translate }}
      </p>

      @if (files().length) {
        <div class="erf-field">
          <p class="erf-field__label">{{ 'ERROR_REPORTING.FORM.FILES_LABEL' | translate }}</p>
          <p class="erf-field__note">{{ 'ERROR_REPORTING.FORM.FILES_NOTE' | translate }}</p>
          @if (filesTooLarge()) {
            <p class="erf-field__error" role="alert">{{ 'ERROR_REPORTING.FORM.FILES_TOO_LARGE' | translate }}</p>
          }
          <ul class="erf-files">
            @for (file of files(); track $index) {
              <li>
                <span>{{ file.name }}</span>
                <button
                  type="button"
                  class="erf-link"
                  (click)="removeFile($index)"
                  [attr.aria-label]="'ERROR_REPORTING.FORM.REMOVE_FILE_LABEL' | translate: { name: file.name }">
                  {{ 'ERROR_REPORTING.FORM.REMOVE_FILE' | translate }}
                </button>
              </li>
            }
          </ul>
        </div>
      }
    </fieldset>

    @if (context() && !isFeedback()) {
      <div class="erf-tech">
        <button
          type="button"
          class="erf-tech__toggle"
          (click)="toggleDetails()"
          [attr.aria-expanded]="detailsExpanded()">
          {{ detailsExpanded() ? '▾' : '▸' }} {{ 'ERROR_REPORTING.FORM.TECH_TOGGLE' | translate }}
        </button>
        @if (detailsExpanded()) {
          <div class="erf-tech__body">
            <pre class="erf-tech__stack">{{ diagnosticsPreview() }}</pre>
            <p class="erf-tech__note">{{ 'ERROR_REPORTING.FORM.TECH_NOTE' | translate }}</p>
          </div>
        }
      </div>
    }

    @if (status() === 'error' || status() === 'uncertain') {
      <p class="erf-error" role="alert">{{ errorMessage() || 'ERROR_REPORTING.FORM.FAILED' | translate }}</p>
    }

    <div class="erf-actions">
      <button
        type="submit"
        class="erf-btn erf-btn--primary"
        [disabled]="status() === 'sending' || status() === 'uncertain' || !context()">
        @if (status() === 'sending') {
          <span class="erf-spinner" aria-hidden="true"></span> {{ 'ERROR_REPORTING.FORM.SENDING' | translate }}
        } @else {
          {{ (isFeedback() ? 'ERROR_REPORTING.FEEDBACK.SEND' : 'ERROR_REPORTING.FORM.SEND') | translate }}
        }
      </button>
    </div>
  </form>
}
